import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { deviceTypes } from "../../../../../shared/enums/deviceTypes";
import DropDown from "../../../../../shared/components/features/dropDown/DropDown";
import pathRouts from "../../../../../shared/enums/pathRoute";
import classes from './ChangeNmm.module.css'


const ChangeNmm = ({ nmmsByDomain }) => {

    const navigate = useNavigate()
    const { studyGroupId } = useParams();
    const deviceType = useSelector(state => state.responsive.deviceType);
    const [selectedName, setSelectedName] = useState("");

    useEffect(() => {
        const name = nmmsByDomain?.find((n) => String(n.id) === String(studyGroupId))?.name ?? nmmsByDomain?.[0]?.name
        setSelectedName(name);
    }, [nmmsByDomain, studyGroupId]);

    const handleClick = (StudyGroup) => {
        navigate(`/${pathRouts.MYLEARNING}/domain/${StudyGroup?.id}/${StudyGroup?.domainName}`);
    };

    if (nmmsByDomain?.length === 1 || deviceType === deviceTypes.mobile || selectedName?.length === 1) {
        return (    
            <p className={classes.ChangeNmmMobile}>{selectedName}</p>
        );
    }

    return (
        <DropDown
            dropClass={classes.StudyGroupOption}
            optionClassName={classes.SchoolOption}
            value={selectedName}
            hideSelectedInList={true}
            arrowColor={"#010101ff"}
            options={nmmsByDomain?.map((nmm, index) => ({
                key: index,
                value: nmm?.name,
                onClick: () => handleClick(nmm),
            }))}
        />
    );
};

export default ChangeNmm;
